export const ARTICLE_TYPE_LABEL = {
  member_feature: "Cover Feature",
  feature: "Cover Feature",
  spotlight: "Spotlight",
  five_questions: "5 Questions Interview",
  blog: "Members' Desk",
  edit: "The Edit",
  editorial: "Editorial",
  advert: "Advert",
};
